<template>
	<div class="edit-list">
		<div>
			<div v-for="(item, i) in dataList" :key="item._id" class="item">
				<unit-edit-form v-model="dataList[i]" ref="form" :index="i" :config="config.content" :p-unit-store="item.store"></unit-edit-form>
				
				<div class="item-index">{{i + 1}}</div>
				<div class="item-handle flex-center">
					<a class="sort-up" @click="sortHandle(i, 0)"><i class="sf sf-sort-top"></i></a>
					<a class="sort-up" @click="sortHandle(i, i - 1)"><i class="sf sf-sort-up"></i></a>
					<a class="sort-down" @click="sortHandle(i, i + 1)"><i class="sf sf-sort-down"></i></a>
					<a class="sort-down" @click="sortHandle(i, dataList.length - 1)"><i class="sf sf-sort-bottom"></i></a>
					<a v-if="!config.length" @click="removeHandle(i)"><i class="sf sf-cross"></i></a>
				</div>
			</div>
		</div>
		<div v-if="!config.length" class="flex-center">
			<sub-button size="m" icon="add" @click="addHandle">添加一项</sub-button>
		</div>
	</div>
</template>

<script>
	import {createStore, getStore, mapStore} from '@/submodule/assets/script/createStore.js'
	
	export default {
		components: {
			unitEditForm: () => import('./unit_edit_form.vue')
		},
		
		props: {
			config: Object
		},
		
		data() {
			return {
				itemId: 0,
				dataList: []
			}
		},
		
		created() {
			if (this.config.length) {
				this.dataList = Array.from(new Array(this.config.length), item => {
					return {
						_id: this.itemId++,
						store: createStore({
							hidden: {},
							pointsProdut: {}
						})
					};
				});
			}
		},
		
		methods: {
			addHandle() {
				this.dataList.push({
					_id: this.itemId++,
					store: createStore({
						hidden: {},
						pointsProdut: {}
					})
				});
			},
			
			removeHandle(index) {
				this.dataList.splice(index, 1);
			},
			
			sortHandle(index, target) {
				if (target < 0 || target >= this.dataList.length) return;
				let item = this.dataList.splice(index, 1)[0];
				this.dataList.splice(target, 0, item);
			},
			
			set(data) {
				if (this.config.length) {
					this.dataList = Array.from(this.dataList, (item, index) => {
						return Object.assign(data[this.config.code] && data[this.config.code][index] ? data[this.config.code][index] : {}, {
							_id: this.itemId++,
							store: createStore({
								hidden: {},
								pointsProdut: {}
							})
						});
					});
				} else {
					this.dataList = Array.from(data[this.config.code] || [], item => {
						return Object.assign(item, {
							_id: this.itemId++,
							store: createStore({
								hidden: {},
								pointsProdut: {}
							})
						});
					});
				}
			},
			
			async submit() {
				let data = new Array(this.dataList.length);
				if (this.$refs.form) {
					for (let i = 0; i < this.$refs.form.length; i++) {
						let temp = await this.$refs.form[i].submit();
						data[this.$refs.form[i].index] = temp;
					};
				}
				
				return {
					[this.config.code]: data
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/submodule/assets/style/theme';
	
	.edit-list {
		.item {
			position: relative;
			padding: 30px 20px 0;
			border: 1px solid #ddd;
			margin-bottom: 10px;
			background: #F8F8F8;
			
			&:nth-child(1) .sort-up,
			&:nth-last-child(1) .sort-down {
				display: none;
			}
			
			&-index {
				position: absolute;
				left: 0;
				top: 0;
				box-sizing: border-box;
				min-width: 20px;
				padding: 0 5px;
				line-height: 20px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				theme-background(lesser);
			}
			
			&-handle {
				position: absolute;
				right: 2px;
				top: 2px;
				
				a {
					width: 20px;
					height: 20px;
					margin-left: 2px;
					line-height: 20px;
					text-align: center;
					font-size: 13px;
					theme-color(lesser);
					
					&:hover {
						theme-color(main);
					}
				}
			}
		}
	}
</style>
